export default "/images/vendor/flag-icon-css/flags/1x1/mm.svg?7068544f07c5b683b67aeaf8afb43ff1";